module.exports = __webpack_public_path__ + "static/img/iosdownload.4e85004.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iosdownload.png
// module id = kqdk
// module chunks = 0